import { useEffect, useState } from "react";
import { KTSVG as KtSvg } from '../../../_metronic/helpers';
import { base64Encode, xorEncrypt } from '../../utils/global.utils'
import ThreeDotMenu from '../../components/menu-dots/menu-dots'
import { OrderForm } from '../../components/message-form/order-form.component'
import { rushButton } from "../../services/order.service";

const RenderRushActionRow = ({
    params,
    tableStateType,
    auth,
    results,
    navigate,
    setShowPopup,
    setModalOpen,
}: any) => {
    const [rowParams, setRowParams] = useState<any>({});
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [buttonType, setButtonType] = useState('');
    const [apiDatatoSend] = useState({ email: '', fileNumber: '', transactionId: '' });
    const [isOpen, setIsOpen] = useState(false);
    const userEmail = auth?.email;

    useEffect(() => {
        if (params) setRowParams(params);
    }, [params]);

    const row = rowParams?.row ?? rowParams;

    const menuOptions: any[] = [
        {
            label: tableStateType === 'done' ? 'Rundown' : 'Rush',
            icon: (
                <KtSvg
                    path="/media/ATR/icons/Icon awesome-shipping-fast.svg"
                    className="svg-icon-1 mr-icon"
                />
            ),
            onclick: () => {
                if (row && userEmail && !isButtonClicked) {
                    if (tableStateType === 'done') {
                        const encodeOid = base64Encode(xorEncrypt(row.orderID.toString()))
                        navigate(`/orders/rundown/${encodeOid}`, {
                            state: { data: row.orderID, results, isDashboard: true },
                        })
                    } else {
                        rushButton(userEmail, row.fileNumber, row.assignedTo?.id, row.transactionId)
                        setShowPopup(true);
                    }
                }
            },
            disable: isButtonClicked,
        },
    ];

    if (tableStateType === 'done') {
        menuOptions.push({
            label: 'Cover',
            onclick: () => {
                const encodeOid = base64Encode(xorEncrypt(row.orderID.toString()));
                navigate(`/orders/coverRecord/${encodeOid}`, {
                    state: { data: row.orderID, results, isDashboard: true },
                })
            },
            disable: isButtonClicked,
        });
    }

    return (
        <div>
            <div className='main-three-dot-menu'>
                <ThreeDotMenu options={menuOptions} setModalOpen={setModalOpen} setButtonType={setButtonType} />
            </div>
            <OrderForm apiDatatoSend={apiDatatoSend} open={isOpen} setOpen={setIsOpen} buttonType={buttonType} />
        </div>
    );
};
export { RenderRushActionRow }